/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon16Solid = forwardRef('BookNotepadIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 3.5a2.5 2.5 0 0 1 2-2.45v13.9a2.5 2.5 0 0 1-2-2.45v-9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 15H5V1h6.5A2.5 2.5 0 0 1 14 3.5v9a2.5 2.5 0 0 1-2.5 2.5Zm-4-11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM7 6.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM7.5 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" })));
});
